<template>
		<v-card class="h-100">
			<!-- ***************************************************************************************** -->
			<v-list class="pa-1">
			    <v-list-tile avatar>
		    		<v-layout mt-4 v-show="!isLogin" class="align-center pointer" @click="showLoginModal">
						<v-list-tile-avatar>
				    		<v-btn icon large slot="activator" class="ma-0">
			                    <v-icon color="primary">fas fa-user-circle</v-icon>
			                </v-btn>
				    	</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title>
								<a class="font-lg">{{$t('header.login')}}</a>
							</v-list-tile-title>
				        </v-list-tile-content>
		    		</v-layout>
		    		<v-layout mt-4 v-show="isLogin" class="align-center pointer" @click="goUserData">
						<v-list-tile-avatar color="primary">
					    	<img v-if="user != null && user.image != null" :src="user.image" />
					    	<span v-else class="headline white--text">
				                {{ user != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '' }}
				            </span>
				    	</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title class="primary--text">
								{{user != null ? user.nickName : ''}}
								<span class="ml-2"></span>
								(@{{user != null ? user.userName : ''}})
							</v-list-tile-title>
				        </v-list-tile-content>
		    		</v-layout>
			    </v-list-tile>
			</v-list>
			<v-divider></v-divider>
			<!-- ***************************************************************************************** -->
			<v-list class="pt-0 Slogan" v-show="isLogin">
				<!-- ***************************************************************************************** -->
				<v-list-tile @click="routerPage('wallet')">
					<v-list-tile-action class="ml-2">
		            	<v-icon>fas fa-wallet</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>
		            		<v-layout>
		            			<v-flex xs6>
			            			<span class="font-22 primary--text fw-700">{{ ((user != null ? user.iobPower : 0).toFixed(2))|NumFormat }}</span>
			            		</v-flex>
			            		<v-flex xs6>
			            			<span>IOB Power</span>
			            		</v-flex>
		            		</v-layout>
						</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
	        	<v-list-tile>
					<v-list-tile-action class="ml-2">
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>
		            		<v-layout>
		            			<v-flex xs6>
			            			<span>{{ ((user != null ? user.iobTokens : 0).toFixed(2))|NumFormat }}</span>
			            		</v-flex>
			            		<v-flex xs6>
			            			<span>IOB Tokens</span>
			            		</v-flex>
		            		</v-layout>
						</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
	        	<v-list-tile>
					<v-list-tile-action class="ml-2">
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>
		            		<v-layout>
		            			<v-flex xs6>
			            			<span>{{ ((user != null ? user.iobPower + user.iobTokens : 0).toFixed(2))|NumFormat }}</span>
			            		</v-flex>
			            		<v-flex xs6>
			            			<span>USD</span>
			            		</v-flex>
		            		</v-layout>
						</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
	        	<v-divider></v-divider>
	        	<!-- ***************************************************************************************** -->
				<v-list-tile @click="routerPage('profile')">
					<v-list-tile-action class="ml-2">
		            	<v-icon>account_box</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{ $t('menu.profile') }}</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
	        	<!-- ***************************************************************************************** -->
	        	<v-list-tile @click="routerPage('signOut')">
					<v-list-tile-action class="ml-2">
		            	<v-icon>fas fa-sign-out-alt</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{ $t('menu.signOut') }}</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
	        	<v-divider></v-divider>
	        	<!-- ***************************************************************************************** -->
	        	<v-list-tile @click="routerPage('myFeed')">
					<v-list-tile-action class="ml-2">
		            	<v-icon>fas fa-rss-square</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{ $t('right.myFeed') }}</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
	        	<!-- ***************************************************************************************** -->
	        	<v-list-tile @click="routerPage('profile')">
					<v-list-tile-action class="ml-2">
		            	<v-icon>fas fa-comment-alt</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{ $t('menu.posts') }}</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
	        	<!-- ***************************************************************************************** -->
	        	<v-list-tile @click="routerPage('profile')">
					<v-list-tile-action class="ml-2">
		            	<v-icon>fas fa-comments</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{ $t('menu.comments') }}</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
	        	<!-- ***************************************************************************************** -->
	        	<v-list-tile @click="routerPage('profile')">
					<v-list-tile-action class="ml-2">
		            	<v-icon>fa fa-reply</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{ $t('menu.replies') }}</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
	    	</v-list>
	    	<v-list class="pt-0 Slogan">
	    		<!-- ***************************************************************************************** -->
	        	<v-list-tile @click="routerPage('searchUser')" class="d-none">
					<v-list-tile-action class="ml-2">
		            	<v-icon>fa fa-user-plus</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{ $t('menu.searchUser') }}</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
	        	<!-- ***************************************************************************************** -->
	        	<v-list-tile @click="routerPage('userRanking')">
					<v-list-tile-action class="ml-2">
		            	<v-icon>fas fa-bolt</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{ $t('menu.IOBPowerRanking') }}</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
				<!-- ***************************************************************************************** -->
				<!-- 全部的tags -->
				<!-- <v-list-tile @click="routerPage('tags')">
					<v-list-tile-action class="ml-2">
		            	<v-icon>fas fa-tag</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{$t('menu.tags')}}</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile> -->
	    	</v-list>
	    	<v-divider></v-divider>
	    	<!-- ***************************************************************************************** -->
	    	<v-list class="pt-0">
				<v-list-group>
		        	<v-list-tile slot="activator" class="">
		        		<v-list-tile-action class="ml-2">
			            	<v-icon>translate</v-icon>
			            </v-list-tile-action>
			            <v-list-tile-content>
			            	<v-list-tile-title>{{ $t('menu.language') + $t('menu.locale') }}</v-list-tile-title>
			            </v-list-tile-content>
		    		</v-list-tile>
					<v-list-tile class="ml-5">
					    <v-radio-group v-model="languageModel" class="ml-2">
					    	<v-radio color="primary" label="English" value="en-US"></v-radio>
					    </v-radio-group>
		    		</v-list-tile>
		    		<v-list-tile class="ml-5">
					    <v-radio-group v-model="languageModel" class="ml-2">
					    	<v-radio color="primary" label="Deutsch" value="de-DE"></v-radio>
					    </v-radio-group>
		    		</v-list-tile>
		    		<v-list-tile class="ml-5">
					    <v-radio-group v-model="languageModel" class="ml-2">
					    	<v-radio color="primary" label="Pусский" value="ru-RU"></v-radio>
					    </v-radio-group>
		    		</v-list-tile>
		    		<v-list-tile class="ml-5">
					    <v-radio-group v-model="languageModel" class="ml-2">
					    	<v-radio color="primary" label="中文（简体）" value="zh-CN"></v-radio>
					    </v-radio-group>
		    		</v-list-tile>
		    	</v-list-group>
			</v-list>
			<!-- ***************************************************************************************** -->
	    	<v-list-tile class="pt-0 pointer">
				<v-list-tile-action class="ml-2">
	            	<v-icon>brightness_4</v-icon>
	            </v-list-tile-action>
	            <v-list-tile-content>
	            	<v-list-tile-title>{{ $t('menu.darkTheme') }}</v-list-tile-title>
	            </v-list-tile-content>
	            <v-list-tile-action>
	            	<v-switch color="primary" v-model="darkModeModel" ></v-switch>
	            </v-list-tile-action>
	    	</v-list-tile>
			<!-- <v-list class="pt-0">
				<v-list-group>
		        	<v-list-tile slot="activator">
		        		<v-list-tile-action class="ml-2">
			            	<v-icon>brightness_4</v-icon>
			            </v-list-tile-action>
			            <v-list-tile-content>
			            	<v-list-tile-title>{{ $t('menu.darkTheme') }}</v-list-tile-title>
			            </v-list-tile-content>
		    		</v-list-tile>
					<v-list-tile>
					    <v-switch color="primary" v-model="darkModeModel" :label="darkMode ? this.$t('menu.dark') : this.$t('menu.light')"></v-switch>
		    		</v-list-tile>
		    	</v-list-group>
			</v-list> -->
			<!-- ***************************************************************************************** -->
			<v-list class="pt-0 mb-5">
				<!-- <v-list-group>
		        	<v-list-tile slot="activator">
		        		<v-list-tile-action class="ml-2">
			            	<v-icon>settings</v-icon>
			            </v-list-tile-action>
			            <v-list-tile-content>
			            	<v-list-tile-title>{{ $t('menu.setting') }}</v-list-tile-title>
			            </v-list-tile-content>
		    		</v-list-tile>
					<v-list-group no-action sub-group value="false">
				        <v-list-tile slot="activator">
				            <v-list-tile-title>{{ $t('menu.selectStyle') }}</v-list-tile-title>
				        </v-list-tile>
				        <v-list-tile>
				        	<v-avatar size="24" v-for="theme in themes" :key="theme.id" :color="theme.bgColor" class="pointer mr-2" @click="changeTheme(theme)"></v-avatar>
				        </v-list-tile>
				    </v-list-group>
		    	</v-list-group> -->
				<!-- ***************************************************************************************** -->
		    	<v-list-group>
		        	<v-list-tile slot="activator" class="">
		        		<v-list-tile-action class="ml-2">
			            	<v-icon>fas fa-palette</v-icon>
			            </v-list-tile-action>
			            <v-list-tile-content>
			            	<v-list-tile-title>{{ $t('menu.style') }}</v-list-tile-title>
			            </v-list-tile-content>
		    		</v-list-tile>
					<v-list-tile>
					    <v-avatar size="24" v-for="theme in themes" :key="theme.id" :color="theme.bgColor" class="pointer mr-2" @click="changeTheme(theme)"></v-avatar>
		    		</v-list-tile>
		    	</v-list-group>
		    	<v-list-tile v-show="isLogin" @click="routerPage('userSetting')">
					<v-list-tile-action class="ml-2">
		            	<v-icon>fa fa-cog</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{ $t('header.settings') }}</v-list-tile-title>
		            </v-list-tile-content>
		    	</v-list-tile>
		    	<!-- ***************************************************************************************** -->
		    	<v-list-tile @click="routerPage('userRequest')">
					<v-list-tile-action class="ml-2">
		            	<v-icon>message</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{ $t('menu.sendFeedback') }}</v-list-tile-title>
		            </v-list-tile-content>
		    	</v-list-tile>
			</v-list>
			<!-- dense可以将整体变小 -->
			<!-- <v-list class="pt-0">
				<v-list-tile v-for="item in mainMenuItems" :key="item.title" @click="routerPage(item.name)">
					<v-list-tile-action>
		            	<v-icon>{{ item.icon }}</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{ item.title }}</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
	    	</v-list>
	    	<v-divider></v-divider>
	    	<v-list class="pt-0">
				<v-list-tile v-for="item in viceMenuItems" :key="item.title" @click="routerPage(item.name)">
					<v-list-tile-action>
		            	<v-icon>{{ item.icon }}</v-icon>
		            </v-list-tile-action>
		            <v-list-tile-content>
		            	<v-list-tile-title>{{ item.title }}</v-list-tile-title>
		            </v-list-tile-content>
	        	</v-list-tile>
	    	</v-list> -->
	    </v-card>
</template>

<script>
import Vue from 'vue'
import config from '../config.js'
import { mapGetters } from "vuex";
import { eventBus } from '../assets/js/eventBus.js'
export default {
	data() {
	    return {
	    	token: this.$store.state.user.token,
	    	drawer: null,
	    	languageModel: this.$store.getters.locale,
	    	darkModeModel: this.$store.getters.darkMode,
	        mainMenuItems: [
	        	// { title: this.$t('menu.home'), name: 'home', icon: 'fa fa-home' },
	        	// { title: this.$t('menu.microArticle'), name: 'microArticles', icon: 'fa fa-file' },
	        	{ title: this.$t('menu.searchUser'), name: 'userSearch', icon: 'fa fa-user-plus' },
	        	// { title: this.$t('menu.tokenTracker'), name: 'transaction', icon: 'fa fa-chart-bar' },
	        	{ title: this.$t('menu.IOBPowerRanking'), name: 'userRanking', icon: 'fa fa-chart-bar' },
	        ],
	        viceMenuItems: [
	        	{ title: this.$t('menu.GDPR'), name: 'GDPR', icon: 'mdi-star-circle' },
	        	{ title: this.$t('menu.privacy'), name: 'privacy', icon: 'fa fa-user-lock' },
	        	{ title: this.$t('menu.AML'), name: 'AML', icon: 'fas fa-user-shield' },
	        	{ title: this.$t('menu.support'), name: 'userRequest', icon: 'far fa-question-circle' }
	        ]
	    };
	},
	computed: {
		...mapGetters([ "darkMode", "themes", "selectedTheme", "user" ]),
        isLogin() {
            if(this.$store.state.user.token != null && this.$store.state.user.token != ''){
                return true;
            }else{
                return false;
            }
        }
    },
    created(){
    	// 数字格式化
	    Vue.filter('NumFormat', function(value) {
	     if(!value) return '0.00';
	       var intPart = Number(value).toFixed(0); //获取整数部分
	       intPart = intPart > value ? intPart - 1 : intPart; // 若四舍五入进了1则减去1
	       var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
	       var floatPart = ".00"; //预定义小数部分
	       var value2Array = value.split(".");
	       //=2表示数据有小数位
	       if(value2Array.length == 2) {
	        floatPart = value2Array[1].toString(); //拿到小数部分
	        if(floatPart.length == 1) { //补0,实际上用不着
	         return intPartFormat + "." + floatPart + '0';
	        } else {
	         return intPartFormat + "." + floatPart;
	        }
	       } else {
	        return intPartFormat + floatPart;
	       }
	    })
    },
	mounted(){

    },
    watch:{
    	darkModeModel(newVal, oldVal){
			this.emitDarkMode(newVal);
		},
		languageModel(newVal, oldVal){
			this.changeLanguage(newVal);
		}
    },
	methods: {
		//路由到用户主页
		goUserData(){
			this.$router.push({name:'userData', params: {username: '@' + this.$store.state.user.name}})
		},
		//显示登录模态框
        showLoginModal(){
            this.$store.state.loginModal = true;
        },
        //退出
		logout(){
			// localStorage.clear();
			localStorage.removeItem("SIP-user");
      		localStorage.removeItem("SIP-role");
      		localStorage.removeItem("userName");
      		localStorage.removeItem("id");
      		localStorage.removeItem("token");
      		localStorage.removeItem("image");
      		localStorage.removeItem("invitationCode");
            this.$store.state.user.id = null;
            this.$store.state.user.name = null;
            this.$store.state.user.token = null;
            this.$store.state.user.image = null;
            this.$router.push({name:'home'});
            this.$router.go();
		},
		//路由到页面
		routerPage(name){
			switch (name) {
				case "myFeed":
		           	this.goMyFeed();
		            break;
				case "profile":
		           	this.goUserData();
		            break;
	            case "userData":
                    this.goUserData();
                    break;
                case "follow":
                    this.goFollow();
                    break;
		        case "wallet":
                        this.goWallet();
                    break;
                case "userSetting":
                    this.goUserSetting();
                    break;
				case "language":
		           	this.changeLanguage();
		            break;
		        case "signOut":
				 	this.logout();
		            break;
		        case "dark":
				 	this.emitDarkMode();
		            break;
                case "home":
                    this.$router.push({name:'home'});
                    break;
                case "microArticles":
                    this.$router.push({name:'microArticles'});
                    break;
                case "searchUser":
                    eventBus.$emit('isShowUserSearchSidebar', true)
                    break;
                case "transaction":
                	this.$router.push({name:'transaction'});
                    break;
                case "userRequest":
                	this.$router.push({name:'userRequest'});
                    break;
                case "userRanking":
                	this.$router.push({name:'userRanking'});
                    break;
                case "GDPR":
                	this.$router.push({name:'GDPR'});
                    break;
                case "privacy":
                	this.$router.push({name:'privacy'});
                    break;
                case "AML":
                	this.$router.push({name:'AML'});
					break;
				case "tags":
                	this.$router.push({name:'tags'});
                    break;
                default:
                    break;
            }
		},
		//跳转关注页面
		goMyFeed(){
			if(this.$store.state.user.token != null && this.$store.state.user.token != ''){
				  this.$router.push({name:'feed', params: {username: '@' + this.$store.state.user.name}})
			}
			else{
				this.$store.state.loginModal = true;
			}
		},
		goWallet(){
            this.$router.push({name:'wallet'})
        },
        goUserSetting(){
            this.$router.push({name:'userSetting'})
        },
        goFollow(){
            this.$router.push({name:'follow', params: {username: '@' + this.$store.state.user.name}})
        },
		//切换语言
		changeLanguage(locale){
			if (this.$store.state.user.token) {
				let userInfo = {'userId': this.$store.getters.user.userId, 'i18nCode': locale};
	            let api = config.baseUrl + 'userDetail/updateI18n';
	            this.$http.post(api, userInfo).then(response => {
	                let data = response.data;
	                if (data.resCode == 0) {
	                	// this.$i18n.locale = data.result.code;
						this.$store.dispatch("localeHandler", data.result.code);
	                    this.$router.go();
	                }
	            });
			} else {
				// this.$i18n.locale = locale;
				this.$store.dispatch("localeHandler", locale);
				this.$router.go();
			}
		},
		emitDarkMode(darkMode){
        	// console.log(this.$store.getters.darkMode)
        	if (this.$store.state.user.token) {
        		let api = config.baseUrl + 'userRight/updateDarkMode?userId=' + this.$store.getters.user.userId + '&darkMode=' + darkMode;
        		this.$http.get(api).then(response => {

        		});
        	}
        	this.$store.dispatch("darkModeHandler", darkMode);
	    	localStorage.setItem('SIP-darkMode', darkMode ? 1 : 0);
	    },
	    changeTheme(theme) {
	    	if (this.$store.state.user.token) {
        		let api = config.baseUrl + 'userRight/updateColorStyle?userId=' + this.$store.getters.user.userId + '&colorStyle=' + theme.bgColor;
        		this.$http.get(api).then(response => {

        		});
        	}
	    	this.$store.dispatch("changeThemeHandler", theme);
	        this.$vuetify.theme = theme.theme;
	        localStorage.setItem('SIP-colorStyle', theme.bgColor);
	    }
	}
}
</script>



// WEBPACK FOOTER //
// Menu.vue?1f93c0d0